"use strict";

var moduleName = "card-product";

module.exports = function () {
	$(".jsCardProduct").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Табы
		//

		$(".jsCardProductTabsNavItem").on("click", function(e) {
			e.preventDefault();

			if($(this).children(".jsCardProductTabsNavLink").hasClass("active") == 0) {
				var numberTabsNav = $(this).index();

				$(".jsCardProductTabsNavLink").removeClass("active");
				$(this).children(".jsCardProductTabsNavLink").addClass("active");


				$(".jsCardProductTabsContentItem").hide();
				$(".jsCardProductTabsContentItem:eq("+numberTabsNav+")").show(200);
			};
		});






		//
		// Отзывы
		//

		$(".jsBtnOpenReviews").on("click", function(e) {
			e.preventDefault();

			$(".jsTabReviews").click();
		});

		$(".jsCardProductReviewsBtn").on("click", function(e) {
			e.preventDefault();

			$(this).addClass("active");
			$(".jsCardProductReviewsForm").show(200);
		});

		$(".jsCardProductReviewsBtnShowAll").on("click", function(e) {
			e.preventDefault();

			if($(this).hasClass("active")) {
				$(this).removeClass("active").html("<span>Показать все</span>");
				$(".jsCardProductReviewsListItem:not(:lt(3))").hide(200);
			} else {
				$(this).html("<span>Свернуть</span>").addClass("active");
				$(".jsCardProductReviewsListItem").show(200);
			}
		});






		//
		// Купить
		//

		$(".jsBtnProductBuy").on("click", function(e) {
			e.preventDefault();

			$(this).hide();
			$(this).parent().find('.jsBtnProductInCart').css("display", "inline-block");
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/cardProductInit.js
 **/